var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBuilding = function SvgBuilding(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-72": 53,
    viewBox: "0 0 17.6 16.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 4.5a.76.76 0 0 0-.75.75v9a.76.76 0 0 0 .75.75h.5V9.75A.76.76 0 0 1 3.5 9h4a.76.76 0 0 1 .75.75V15h7a.76.76 0 0 0 .75-.75v-9a.76.76 0 0 0-.75-.75zM6.75 15h-2.5v-4.5h2.5zm-4.5 1.5h13a2.25 2.25 0 0 0 2.25-2.25v-9A2.25 2.25 0 0 0 16 3.129V2.25A2.25 2.25 0 0 0 13.75 0h-10A2.25 2.25 0 0 0 1.5 2.25v.879A2.25 2.25 0 0 0 0 5.25v9a2.25 2.25 0 0 0 2.25 2.25M14.5 3v-.75a.76.76 0 0 0-.75-.75h-10a.76.76 0 0 0-.75.75V3zm-3.75 7.5h3a.75.75 0 1 0 0-1.5h-3a.75.75 0 1 0 0 1.5m3 3h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 1 1 0 1.5m-3-6h3a.75.75 0 1 0 0-1.5h-3a.75.75 0 1 0 0 1.5",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBuilding);
export default ForwardRef;